import { useAchievements } from '../../api/queries';
import { AchievementIcon } from '../../components/AchievementIcon';
import { QueryBoundary } from '../../components/QueryBoundary';
import { useTranslation } from '../../i18n/I18nProvider';
import { formatDate } from '../../lib/format';
import { SkeletonList } from '../../ui';

/**
 * Postignuća.
 *
 * Server šalje isključivo otključana (`GET /v1/achievements`) i to je namjerno:
 * popis onoga što netko NEMA ne motivira, nego podsjeća na neuspjeh. Zato ovdje
 * nema sivih, zaključanih pločica — mreža raste kako klijent napreduje.
 * `label` i `icon` stižu sa servera, prevedeni; portal ih ne izmišlja.
 */
export function AchievementsSection() {
  const { t, locale } = useTranslation();
  const query = useAchievements();

  return (
    <section data-testid="achievements">
      <h2 className="eyebrow mb-3">{t('achievements.title')}</h2>
      <QueryBoundary
        query={query}
        skeleton={<SkeletonList rows={2} />}
        isEmpty={(d) => d.items.length === 0}
        empty={{ message: t('achievements.empty') }}
      >
        {(data) => (
          <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {data.items.map((a) => (
              <li
                key={a.key}
                data-testid="achievement"
                className="flex flex-col items-center gap-2 rounded-xl border border-line-subtle bg-surface px-4 py-5 text-center shadow-card"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-pill bg-accent-light text-accent-deep">
                  <AchievementIcon name={a.icon} size={22} />
                </span>
                <span className="text-[14px] leading-snug text-ink">{a.label}</span>
                <span className="text-[12px] text-ink-muted">
                  {formatDate(a.unlockedAt, locale)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </QueryBoundary>
    </section>
  );
}
